import { render, staticRenderFns } from "./OtherProjects.vue?vue&type=template&id=6cef8746&"
import script from "./OtherProjects.vue?vue&type=script&lang=ts&"
export * from "./OtherProjects.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports